export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VeranoPage.vue?vue&type=template&id=48fcef63&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/inscripciones/VeranoPage.vue?vue&type=template&id=48fcef63&scoped=true&
// module id = 684
// module chunks = 23